import React from 'react'
import { Result, Row, Col, theme, Typography } from 'antd'

function ThankYou() {
  const { token } = theme.useToken()
  const contactEmail = 'admin@goodtobook.com'

  return (
    <Row style={{ minHeight: '100vh', backgroundColor: token.colorBgLayout }}>
      <Col xs={20} md={18} lg={18} xl={14} style={{ margin: '0 auto', padding: '50px 0' }}>
        <Result
          status="success"
          title="Thank You for Registering!"
          subTitle={
            <div style={{ textAlign: 'center' }}>
              <Typography.Paragraph>
                Your Good to Book membership application has been received and is being processed; you&apos;ll receive a confirmation email within 48 hours, after which you&apos;ll join our community dedicated to exceptional accommodation services free from Rogue Guests.
              </Typography.Paragraph>
              <Typography.Paragraph>
                For more information,{' '}
                <a
                  href={`mailto:${contactEmail}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: token.colorPrimary }}
                >
                  {contactEmail}
                </a>
              </Typography.Paragraph>
              <Typography.Paragraph>
                <img src="/logo-stacked-black.jpg" width={100} height={75} alt="" />
              </Typography.Paragraph>
            </div>
          }
        />
      </Col>
    </Row>
  )
}

export default ThankYou
